// Stub Redux store for BIM project
import { configureStore } from "@reduxjs/toolkit";
import currentUserReducer from "./slices/misc/currentUser";
import highlightReducer from "./slices/misc/highlightSlice";
import notificationReducer from "./slices/misc/notificationSlice";
import menuReducer from "./slices/misc/menuSlice";
import viewerReducer from "./slices/bim/viewerSlice";

const store = configureStore({
  reducer: {
    misc: (state = {}) => state,
    currentUser: currentUserReducer,
    highlight: highlightReducer,
    notification: notificationReducer,
    menu: menuReducer,
    viewer: viewerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
